var map = {
	"./adddoc.png": 8060,
	"./addimage.png": 8546,
	"./avatar.png": 8308,
	"./cancel.png": 7160,
	"./comingsoon.png": 7549,
	"./confidential.png": 232,
	"./cost.png": 647,
	"./delivery.png": 6323,
	"./document.png": 3125,
	"./environment.png": 8805,
	"./error.png": 5551,
	"./isempty.png": 9404,
	"./level2.png": 8478,
	"./loading.gif": 6053,
	"./logo.png": 6949,
	"./maintenance.png": 5549,
	"./morale.png": 3600,
	"./ok.png": 6080,
	"./oops.png": 5005,
	"./productivity.png": 3931,
	"./quality.png": 9398,
	"./reviewdoc.jpg": 5883,
	"./safety.png": 5183,
	"./save.png": 1113,
	"./success.png": 8296,
	"./tsc.png": 7746,
	"./unavailable.png": 3687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;